import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
  AreaChart,
} from "recharts";
import type { RevenueTrendItem } from "../../api/dashboardApi";

interface RevenueTrendChartProps {
  data: RevenueTrendItem[];
}



const formatCompact = (value: number) => {
  if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)} M`;

  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(0)} Jt`;

  if (value >= 1_000) return `${(value / 1_000).toFixed(0)} Rb`;

  return String(value);
};

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value);

function CustomTooltip({ active, payload, label }: any) {
  if (!active || !payload || !payload.length) return null;

  return (
    <div className="rounded-xl bg-[#324A5A] px-4 py-2.5 text-white shadow-lg">
      <p className="text-sm">{label}</p>

      <p className="text-sm font-semibold">
        {formatCurrency(payload[0].value)}
      </p>
    </div>
  );
}

export default function RevenueTrendChart({ data }: RevenueTrendChartProps) {

  const maxValue = Math.max(...data.map((item) => item.total));

  const yAxisMax =
    maxValue === 0
      ? 100
      : Math.ceil((maxValue * 1.1) / 100_000_000) * 100_000_000;
  const minWidth = Math.max(900, data.length * 80);
  return (

    
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart
        data={data}
        margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
        <defs>
          <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#3DA4A8" stopOpacity={0.35} />
            <stop offset="100%" stopColor="#3DA4A8" stopOpacity={0} />
          </linearGradient>
        </defs>

        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#F1F5F9"
        />

        <XAxis
          dataKey="period"
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: "#94A3B8" }}
        />

        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: "#94A3B8" }}
          domain={[0, yAxisMax]}
          tickFormatter={formatCompact}
        />

        <Tooltip content={<CustomTooltip />} />

        <Area
          type="monotone"
          dataKey="total"
          stroke="#3DA4A8"
          strokeWidth={2.5}
          fill="url(#revenueGradient)"
          dot={{ r: 4, fill: "#3DA4A8", strokeWidth: 2, stroke: "#fff" }}
          activeDot={{ r: 6 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
